import { render, staticRenderFns } from "./FiscalData.vue?vue&type=template&id=61d39e64"
import script from "./FiscalData.vue?vue&type=script&lang=js"
export * from "./FiscalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Forms/FiscalData.vue
// module id = 1515
// module chunks = 31